// extracted by mini-css-extract-plugin
export default {"pagebreak":"dealAnalyzer_pagebreak__EA6c4"};